import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { SegmentsParams } from './segments-navigation-params.interface';
import { Segment } from '../segment.interface';


@Injectable()
export class SegmentsNavigationService {

  model: any = {
    segments: [],
    btnWidth: 158,
    sideNavSize: 100,
    marginLeft: 35,
    rightPaginationWidth: 125,
    navPosition: 0,
    active: null,
    activeIndex: 0,
  };

  init(params: SegmentsParams = {
    segments: [],
    btnWidth: 158,
    sideNavSize: 100,
    marginLeft: 35,
    rightPaginationWidth: 125
  }) {
    Object.assign(this.model, params);
  }

  public get containerWidth(): number {
    return this.model.btnWidth * this.model.segments.length;
  }

  public get isPrevDisabled(): boolean {
    return this.model.navPosition === 0;
  }

  public get scrollingArea(): number {
    const area = window.innerWidth - this.model.sideNavSize
                             - this.model.marginLeft
                             - this.model.rightPaginationWidth;
    const buttonsCount = Math.round(area / this.model.btnWidth);
    const buttonsArea = buttonsCount * this.model.btnWidth;
    if (buttonsArea > area) {
      return buttonsArea - this.model.btnWidth;
    } else {
      return buttonsArea;
    }
  }

  public get isNextDisabled(): boolean {
    return (this.containerWidth + this.model.navPosition <= this.scrollingArea);
  }

  public setActive(name: string): void {
    _.forEach(this.model.segments, (segment: Segment, index: number) => {
      segment.active = false;
      if (segment.name === name) {
        segment.active = true;
        this.model.active = segment;
        this.model.activeIndex = index;
      }
    });
  }

  public reset() {
    this.model = {};
  }

  changeNavPosition(direction: number): void {
    this.model.navPosition = this.model.navPosition - this.model.btnWidth * direction;
  }

  scrollToIndex(index: number) {
    if (this.model.btnWidth * index <= Math.abs(this.model.navPosition)) {
      this.model.navPosition = -this.model.btnWidth * index;
      return;
    }
    const visibleBtns = Math.round(this.scrollingArea / this.model.btnWidth);
    this.model.navPosition = -this.model.btnWidth * Math.abs(index - visibleBtns + 1);
  }

}
